// src/store/action.js
import { Login, User } from "@/api/login.js";
import { MapUtil } from "@/api/app.js";
import locationService from "@/utils/location.js";

const task = async () => {
  try {
    console.log("【定时上报】正在上报用户位置...");
    
    // 使用完整的定位流程，包括权限检查和区域码获取
    const locationInfo = await locationService.getLocationWithAreaCode();
    console.log('【定时上报】正在获取用户位置', locationInfo);

    if (locationInfo) {
      console.log('【定时上报】已经获取用户位置', locationInfo);
      const obj = {
        longitude: locationInfo.longitude,
        dimension: locationInfo.latitude,
        areaname: locationInfo.cityName,
        areacode: locationInfo.areaCode,
        type: localStorage.getItem('usertype') || '',
      };
      Login.addPosition(obj);

      // 如果当前有运输中的订单，同步保存轨迹
      if (localStorage.getItem('orderid')) {
        console.log('【定时上报】如果当前有运输中的订单，同步保存轨迹', localStorage.getItem('orderid'));
        Login.orderTracksSave({
          orderid: localStorage.getItem('orderid'),
          longitude: locationInfo.longitude,
          dimension: locationInfo.latitude,
          type: localStorage.getItem('usertype') || '',
        });
      } else {
        console.log('【定时上报】没有运输中的订单，同步保存轨迹', localStorage.getItem('orderid'));
      }
    }
  } catch (err) {
    console.error("定位或上报失败", err);
  }
}

const action = {
  // 启动定位定时器
  async startLocationUpdate({ commit, state }) {
    // 立即执行一次
    task();
    console.log("【定时上报】启动定位定时器")
    const data = {
      areaname: localStorage.getItem('addressName') || '',
      areacode: localStorage.getItem('addressCode') || '',
      usertype: localStorage.getItem('usertype') || '',
      usercode: localStorage.getItem('usercode') || '',
      phone: localStorage.getItem('phone') || '',
      orderid: localStorage.getItem('orderid') || '',
      userid: localStorage.getItem('userid') || '',
    };
    // 已启动 更新参数
    if (state.locationInterval) {
      console.log('【定时上报】已启动定位定时器...updateParameters');
      let r = await CSDK.callMethod('updateParameters', data);
      console.log('updateParameters', r);
    } else {//未启动
      console.log('【定时上报】启动定位定时器...startAlarm');
      let r = await CSDK.callMethod('startAlarm', data)
      //1、"定位服务已启动"  2、"定位服务启动失败,无权限"  3、"定位服务启动失败,程序异常"
      console.log('startAlarmend回调结果=', r);
      if (r == 1) {
        console.log('【定时上报】定位服务已启动');
        commit('setLocationInterval', true);
      } else if (r == 2) {
        console.log('【定时上报】定位服务启动失败,无权限');
      } else if (r == 3) {
        console.log('【定时上报】定位服务启动失败,程序异常');
      }
    }
  },

  // 停止定时器
  stopLocationUpdate({ commit, state }) {
    if (state.locationInterval) {
      // clearInterval(state.locationInterval);//停止定时器
      commit('setLocationInterval', null);//设为初始值
    }
    CSDK.cancelAlarm()
  }
};

export default action;


// WEBPACK FOOTER //
// ./src/store/action.js